import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers/reducers';
import middlewares from './middlewares/middlewares'
import { updateTheme } from './middlewares/themes.middleware.js';
import { updateClasses } from './middlewares/settings.middleware.js';
import { setWelfareVariant } from '../i18n';
import { setDemoActive, setDemoPhotosActive } from '../anonymization';
import { configurePdfTheme } from '../services/export/pdf/pdfTheme';

import { persistedState, saveState } from './persisted.store.js';

export default function configureStore() {
    const store = createStore(
        reducers,
        persistedState, // second argument overrides the initial state
        applyMiddleware(
            ...middlewares
        )
    );

    // add a listener that will be invoked on any state change
    store.subscribe(() => {
        saveState(store.getState());
        setDemoActive(store.getState()?.zoo?.anonymousMode);
        setDemoPhotosActive(store.getState()?.zoo?.anonymousModePhotos);
        // Thème d'impression du parc (palette, économie d'encre) : tous les
        // exports PDF lisent le réglage actif du moteur commun.
        configurePdfTheme(store.getState()?.zoo?.zooOptions?.printTheme);
    });

    // Update the initial theme
    updateTheme(store.getState())
    // Synchronise les classes body (layout-fixed, offsidebar-open…) dès le
    // boot : sans cet appel, un état de layout ne s'appliquait qu'au passage
    // de la première action de settings — d'où des panneaux qui surgissaient
    // en retard (après le chargement d'une vue, ex. météo du dashboard).
    updateClasses(store.getState())
    setWelfareVariant(store.getState()?.zoo?.zooType === 'lab' ? 'lab' : null)
    // Mode démo : synchronise le flag runtime dès le boot (le state zoo étant
    // persisté, le mode démo survit au refresh)
    setDemoActive(store.getState()?.zoo?.anonymousMode)
    setDemoPhotosActive(store.getState()?.zoo?.anonymousModePhotos)
    configurePdfTheme(store.getState()?.zoo?.zooOptions?.printTheme)


    return store;

}
